<div class="responsive-card">
  <div class="d-flex gap-2 flex-column mb-4">
    <div class="responsive-card-title" i18n>Lump Sum Details</div>
    <div *ngIf="paymentForm?.controls?.forgoRecurringPayments?.value" class="d-flex gap-1 align-items-center">
      <img class="tooltip-img" [src]="'assets/icons/grey/CircleExclamationMark.svg'" alt="question-mark" i18n-alt />
      <div class="info" i18n>Recurring payments forgone</div>
    </div>
  </div>
  <div class="d-flex gap-3 flex-column">
    <app-variable-benefit-lump-sum-payment-details-card
      [amount]="paymentForm?.controls?.lumpSumPaymentAmount?.value"
      [month]="paymentForm?.controls?.lumpSumPaymentMonth?.value"
      [year]="paymentForm?.controls?.lumpSumPaymentYear?.value"
      [forgoRecurringPayments]="paymentForm?.controls?.forgoRecurringPayments?.value" />
  </div>
  <div class="d-flex justify-content-between" [style.margin-top.rem]="2">
    <div class="total" i18n>Total Lump Sum Payments</div>
    <div class="total">{{ paymentForm?.controls?.lumpSumPaymentAmount?.value | currency }}</div>
  </div>
  <div class="helper-text mt-4" *ngIf="paymentForm?.controls?.forgoRecurringPayments?.value" i18n>
    *Amount reflects full balance as of submission date. Final amount may vary based on payment date.
  </div>
</div>
